import React from 'react';

import {
  Label,
  FormLabel,
  SectionContent,
  DateInput,
  DataText,
  GrayedText,
  EmptyText,
  LongSectionContent,
} from './Components';

interface EpisodeOfCareSectionProps {
  id: string;
  label: string;
  selectedDate: string;
  onChange: (date: string, futureDate: string) => void;
}

const EpisodeOfCareSection: React.FC<EpisodeOfCareSectionProps> = ({ id, label, selectedDate, onChange }) => {
  const DAYS_IN_FUTURE = 30;

  const getFutureDate = (date: string, days: number): string => {
    const currentDateObj = new Date(date);
    const futureDateObj = new Date(currentDateObj.getTime() + days * 24 * 60 * 60 * 1000);

    const toDateString = futureDateObj.toISOString().split('T')[0];

    const parts = toDateString.split('-');
    const year = parts[0];
    const month = parts[1];
    const day = parts[2];

    const outputDate = `${month}/${day}/${year}`;

    return outputDate;
  };

  const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const date = event.target.value;
    const futureDate = getFutureDate(date, DAYS_IN_FUTURE);
    onChange(date, futureDate);
  };

  const daysPassed = selectedDate
    ? Math.ceil((new Date().getTime() - new Date(selectedDate).getTime()) / (24 * 60 * 60 * 1000))
    : null;

  const daysPassedText = daysPassed && daysPassed > 0 ? daysPassed?.toString() : '';

  const currentDayElement = (
    <DataText>
      {daysPassedText !== '' ? `day ${daysPassedText} ` : 'Not started'}
      {daysPassedText !== '' && <GrayedText>(out of 30)</GrayedText>}
    </DataText>
  );

  return (
    <>
      <LongSectionContent>
        <FormLabel htmlFor={id}>{label}</FormLabel>

        <DateInput id={id} type="date" value={selectedDate} onChange={handleDateChange} />
      </LongSectionContent>

      <LongSectionContent>
        <Label>Episode ends on:</Label>
        {selectedDate && <DataText>{getFutureDate(selectedDate, DAYS_IN_FUTURE)}</DataText>}
        {!selectedDate && <EmptyText>-</EmptyText>}
      </LongSectionContent>

      <SectionContent>
        <Label>Current day:</Label>

        {selectedDate && currentDayElement}
        {!selectedDate && <EmptyText>-</EmptyText>}
      </SectionContent>
    </>
  );
};

export default EpisodeOfCareSection;
